/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] = globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] || []).push([["template.page"],{

/***/ "./src/scripts/templates/page.js":
/*!***************************************!*\
  !*** ./src/scripts/templates/page.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_default_basic_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/default/basic.scss */ \"./src/styles/default/basic.scss\");\n\n\n//# sourceURL=webpack://@spurit/tropicfeel-kw-new-theme/./src/scripts/templates/page.js?");

/***/ }),

/***/ "./src/styles/default/basic.scss":
/*!***************************************!*\
  !*** ./src/styles/default/basic.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://@spurit/tropicfeel-kw-new-theme/./src/styles/default/basic.scss?");

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ "use strict";
/******/ 
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/scripts/templates/page.js"));
/******/ }
]);